// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.okr-view-list-page-container {
  height: 100vh;
  background-color: #fff;
  display: flex;
  flex-direction: column;
  padding-bottom: 75px;
}
.okr-view-list-page-container .okr-views-container {
  overflow-y: auto;
}
.okr-view-list-page-container .okr-views-container #nothing-found {
  margin-top: 145px;
}
.okr-view-list-page-container .okr-views-container .gridReloading {
  opacity: 0.6;
}
.okr-view-list-page-container .okr-views-container .centered-content-container {
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.okr-view-page-container {
  height: 100vh;
}
.okr-view-page-container .copy-link-form {
  padding: 0px 30px 20px 30px;
}
`, "",{"version":3,"sources":["webpack://./packages/webapp-legacy/src/okrs/okr-views/components/okr-views-list/okr-views-list.component.less","webpack://./packages/webapp-legacy/src/okrs/okr-views/okr-views.module.less","webpack://./packages/webapp-legacy/src/okrs/okr-views/components/okr-view/okr-view.component.less"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,sBAAA;EACA,aAAA;EACA,sBAAA;EACA,oBAAA;ACCF;ADNA;EAQI,gBAAA;ACCJ;ADTA;EAWM,iBAAA;ACCN;ADZA;EAeM,YAAA;ACAN;ADfA;EAmBM,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;ACDN;ACrBA;EACE,aAAA;ADuBF;ACxBA;EAII,2BAAA;ADuBJ","sourcesContent":[".okr-view-list-page-container {\n  height: 100vh;\n  background-color: #fff;\n  display: flex;\n  flex-direction: column;\n  padding-bottom: 75px;\n\n  .okr-views-container {\n    overflow-y: auto;\n\n    #nothing-found {\n      margin-top: 145px;\n    }\n\n    .gridReloading {\n      opacity: 0.6;\n    }\n\n    .centered-content-container {\n      height: 100%;\n      display: flex;\n      justify-content: center;\n      align-items: center;\n    }\n  }\n}\n",".okr-view-list-page-container {\n  height: 100vh;\n  background-color: #fff;\n  display: flex;\n  flex-direction: column;\n  padding-bottom: 75px;\n}\n.okr-view-list-page-container .okr-views-container {\n  overflow-y: auto;\n}\n.okr-view-list-page-container .okr-views-container #nothing-found {\n  margin-top: 145px;\n}\n.okr-view-list-page-container .okr-views-container .gridReloading {\n  opacity: 0.6;\n}\n.okr-view-list-page-container .okr-views-container .centered-content-container {\n  height: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n.okr-view-page-container {\n  height: 100vh;\n}\n.okr-view-page-container .copy-link-form {\n  padding: 0px 30px 20px 30px;\n}\n",".okr-view-page-container {\n  height: 100vh;\n\n  .copy-link-form {\n    padding: 0px 30px 20px 30px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
